module.exports = __webpack_public_path__ + "img/stock.dabab56d.png";